import React from 'react';
import { isTestEnvironment } from './environment';
import AdminHeader from './AdminHeader';

const AdminToolbar = ({ children }) => {
    const isTest = isTestEnvironment();
 
    return (
        <div className={isTest ? 'admin-enabled' : ''}>
            {isTest && <AdminHeader />}
            {children}
        </div>
    );
};

export default AdminToolbar;